import { FC } from 'react';
import { Route, Switch } from 'react-router';

import Beneficiaries from './Pages/Beneficiaries';
import BulkTransfers from './Pages/BulkTransfers';
import CreateNewBeneficiary from './Pages/CreateNewBeneficiary';
import CreateNewTransfer from './Pages/CreateNewTransfer';
import TransfersHome from './Pages/TransfersHome';
import routes from './routes';

export interface TransfersProps {
  match: {
    url: string;
  };
}

const Transfers: FC<TransfersProps> = () => (
  <Switch>
    <Route component={TransfersHome} exact path={routes.root} />
    <Route component={CreateNewBeneficiary} path={routes.newBeneficiary} />
    <Route component={CreateNewTransfer} path={routes.newTransfer} />
    <Route component={BulkTransfers} path={routes.bulkTransfers} />
    <Route component={Beneficiaries} path={routes.beneficiaries} />
  </Switch>
);

export default Transfers;
